var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-stepper",
    {
      staticClass: "pt-2",
      attrs: { "alt-labels": "", flat: "", tile: "", elevation: "0" },
    },
    [
      _c(
        "v-stepper-header",
        _vm._l(_vm.tabs, function (tab, idx) {
          return _c(
            "v-stepper-step",
            {
              key: tab.title,
              staticStyle: { "max-width": "150px" },
              attrs: {
                editable: _vm.isNew ? tab.isEditable : true,
                step: idx + 1,
                rules: _vm.getRules(tab),
              },
            },
            [
              _vm.isNew && !tab.isEditable
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "p",
                                  _vm._g(
                                    _vm._b(
                                      { staticClass: "text-center" },
                                      "p",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm._v(" " + _vm._s(tab.title) + " "),
                                    tab.isOptions
                                      ? _c("small", [_vm._v("(опционально)")])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.tooltipMessages))])]
                  )
                : _c("p", { staticClass: "text-center" }, [
                    _vm._v(" " + _vm._s(tab.title)),
                    tab.isOptions
                      ? _c("small", [_vm._v("(опционально)")])
                      : _vm._e(),
                  ]),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-stepper-items",
        [
          _vm._l(_vm.tabs, function (tab, idx) {
            return _c(
              "v-stepper-content",
              { key: tab.title + idx + 1, attrs: { step: idx + 1 } },
              [_c("router-view")],
              1
            )
          }),
          _vm._l(_vm.tabs, function (tab, idx) {
            return _c(
              "v-stepper-content",
              { key: tab.title + idx, attrs: { step: idx + 1 } },
              [_vm._t(idx)],
              2
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }